module.exports = __webpack_public_path__ + "static/media/surface2.52c4caf1.svg";